import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

const FormatFilter = props => (
  <select
    className="filter-header"
    onChange={props.onChangeFormat}
    value={props.filter.format}
  >
    <option value="">FORMAT</option>
    {props.formatList.map(format => (
      <option key={format.value} value={format.value}>{format.label}</option>
    ))}
  </select>
)

FormatFilter.defaultProps = {
  filter: {
    format: '',
  },
}

FormatFilter.propTypes = {
  formatList: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChangeFormat: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    format: PropTypes.string,
  }),
}

export default FormatFilter
